<template>
    <el-drawer
        title="上传图片"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formDatas"
                :rules="rules"
                ref="formDatas"
                label-position="top"
            >
                <el-form-item prop="imageUrl" label="预览图:" :rules='[{required: true, message: "请上传预览图"}]'>
                    <image-upload 
                        :url.sync="formDatas.imageUrl" 
                        :urlFull.sync="formDatas.imageUrl" 
                        :crop="true"
                        :width="1200"
                        :height="1200"
                        @onSuccess="handleImageSuccess"
                    >
                    </image-upload>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确认</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';

const defaultData = {
    index:0,
    imageUrl:'',
}
export default {
    components:{ImageUpload},
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            formDatas:{
                ...defaultData
            },
            rules:{
                stockNum:[{ required: true, message: "请填写增/减数量" }]
            },
        }
    },
    methods:{
        close(){
            this.$refs.formDatas.resetFields();
            this.drawerShow = false;
            this.formDatas = {
                ...defaultData
            }
        },
        show(data,index){
            this.index = index;
            this.formDatas = {...data,index:index};
            this.drawerShow = true;
        },
        //图片上传成功后执行
        handleImageSuccess(){
            if(this.formDatas.imageUrl){
                this.$refs["formDatas"].clearValidate('imageUrl');
            }
        },
        //表单提交
        submitForm() {
            this.$refs["formDatas"].validate((valid) => {
                if (valid) {
                    this.$emit('updateImg',{...this.formDatas});
                    this.close();
                }
            });
        },
    }
}
</script>